import TravelUIMoFooter from '@travel-ui/mobile-footer';
import {
  BusinessDetails,
  LoginOutButton,
  MiddleSectionButton,
  NavItem,
  NavRow,
  ScrollTopButton,
} from '@travel-ui/mobile-footer/core';

export const disclaimer =
  '네이버 티켓·패키지 여행은 여행 상품 판매사에서 제공한 여행 상품의 정보를 비교, 중개하는 서비스입니다. 네이버(주)는 통신판매의 당사자가 아니며 상품 검색 결과, 구매 및 환불 등에 관련한 의무와 책임은 각 판매자에게 있습니다.';

const MyMoFooter = () => {
  return (
    <TravelUIMoFooter
      className={'travelFooter'}
      topSectionButtons={
        <>
          <ScrollTopButton />
        </>
      }
      middleSectionButtons={
        <>
          <LoginOutButton />
          <MiddleSectionButton href="https://m.naver.com/services.html">전체서비스</MiddleSectionButton>
        </>
      }
      businessDetails={<BusinessDetails />}
      navigations={
        <>
          <NavRow>
            <NavItem url="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=2208162517">사업자정보 공개</NavItem>
            <NavItem url="https://policy.naver.com/policy/service.html">이용약관</NavItem>
          </NavRow>
          <NavRow>
            <NavItem url="https://policy.naver.com/policy/privacy.html">
              <strong>개인정보처리방침</strong>
            </NavItem>
            <NavItem url="https://help.naver.com/alias/contents2/navertravel/travel.naver">고객센터</NavItem>
          </NavRow>
        </>
      }
      disclaimer={disclaimer}
    />
  );
};

export default MyMoFooter;
